import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
import axios from "axios";
export const getFAQ = createAsyncThunk(
  "get/faq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/faqList");
      return response.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);
export const addFAQ = createAsyncThunk(
  "add/faq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addFaq", payload);
      return response.data;
    } catch (error) {
      console.log("Error", error);
      rejectWithValue(error);
    }
  }
);
export const editFAQ = createAsyncThunk(
  "edit/faq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editFaq", payload);
      return response.data;
    } catch (error) {
      console.log("Error", error);
      rejectWithValue(error);
    }
  }
);
export const deleteFAQ = createAsyncThunk(
  "delete/faq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch("deleteFaq", payload);
      return response.data;
    } catch (error) {
      console.log("Error", error);
      rejectWithValue(error);
    }
  }
);
const faqManagment = createSlice({
  name: "faq",
  initialState: {
    faq: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getFAQ.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFAQ.fulfilled, (state, action) => {
      state.loading = false;
      state.faq = action.payload;
    });
    builder.addCase(getFAQ.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default faqManagment.reducer;
